"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = exports.FAILEDTOUPDATE = exports.FAILEDTOCREATE = exports.UPDATED = exports.UPDATING = exports.CREATED = exports.CREATING = exports.FAILED = exports.FETCHED = exports.FETCHING = exports.STANDBY = void 0;
const fp = require("fp-ts");
const monocle = require("monocle-ts");
const ActionTypes = require("../../actionTypes/trmvrmeterentries/current");
exports.STANDBY = 'STANDBY';
exports.FETCHING = 'FETCHING';
exports.FETCHED = 'FETCHED';
exports.FAILED = 'FAILED';
exports.CREATING = 'CREATING';
exports.CREATED = 'CREATED';
exports.UPDATING = 'UPDATING';
exports.UPDATED = 'UPDATED';
exports.FAILEDTOCREATE = 'FAILEDTOCREATE';
exports.FAILEDTOUPDATE = 'FAILEDTOUPDATE';
exports.initialState = {
    status: exports.STANDBY,
    currentEntry: undefined,
    createdEntryUuid: undefined
};
const statusLens = monocle.Lens.fromProp('status');
const currentEntryLens = monocle.Lens.fromProp('currentEntry');
const createdEntryUuidLens = monocle.Lens.fromProp('createdEntryUuid');
exports.methods = {};
exports.methods[ActionTypes.FETCH_REQUEST] = (state, action) => statusLens.set(exports.FETCHING)(state);
exports.methods[ActionTypes.FETCH_SUCCESS] = (state, action) => fp.function.compose(currentEntryLens.set(action.payload), statusLens.set(exports.FETCHED))(state);
exports.methods[ActionTypes.FETCH_FAILED] = (state, action) => statusLens.set(exports.FAILED)(state);
exports.methods[ActionTypes.CLEAR] = (state, action) => (Object.assign({}, exports.initialState));
exports.methods[ActionTypes.CREATE_ENTRY_REQUEST] = (state, action) => statusLens.set(exports.CREATING)(state);
exports.methods[ActionTypes.CREATE_ENTRY_SUCCESS] = (state, action) => fp.function.compose(createdEntryUuidLens.set(action.payload.uuid), statusLens.set(exports.CREATED))(state);
exports.methods[ActionTypes.CREATE_ENTRY_FAILED] = (state, action) => statusLens.set(exports.FAILEDTOCREATE)(state);
exports.methods[ActionTypes.UPDATE_ENTRY_REQUEST] = (state, action) => statusLens.set(exports.UPDATING)(state);
exports.methods[ActionTypes.UPDATE_ENTRY_SUCCESS] = (state, action) => fp.function.compose(currentEntryLens.set(action.payload), statusLens.set(exports.UPDATED))(state);
exports.methods[ActionTypes.UPDATE_ENTRY_FAILED] = (state, action) => statusLens.set(exports.FAILEDTOUPDATE)(state);
//# sourceMappingURL=current.js.map